/**
 * Settings API wrappers (BUILD_SPEC.md §6.7, §5.5).
 *
 * Values come back JSON-decoded from the server; sending them back via
 * `updateSetting` requires the right TypeScript type per key. The
 * `SettingValue` map below is the SPA's compile-time view of the same
 * per-key schema the server enforces in `routes/settings.ts`.
 */

import { api } from "./client";

/** Compile-time map of setting key → value type. Adding a new key
 *  means updating BOTH this map and the API's per-key validator. */
export interface SettingValue {
  archive_working_days: number;
  polling_interval_min: number;
  polling_interval_max: number;
  scraper_concurrency: number;
  weekend_days: string[];
  office_name_ar: string;
  office_name_en: string;
  // §16.1 Notifications — office-wide defaults. The dashboard's
  // local soundStore is the runtime source of truth; these are the
  // audited record of policy and the seed for fresh kiosks.
  sound_master_enabled: boolean;
  sound_approval_enabled: boolean;
  sound_assignment_enabled: boolean;
  sound_rejection_enabled: boolean;
  sound_volume: number;
}

export type SettingKey = keyof SettingValue;

export async function getSettings(): Promise<Partial<SettingValue>> {
  const res = await api.get<{ settings: Partial<SettingValue> }>("/settings");
  return res.data.settings;
}

export async function updateSetting<K extends SettingKey>(
  key: K,
  value: SettingValue[K],
): Promise<void> {
  await api.put("/settings", { key, value });
}
